import React, { useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col } from 'react-bootstrap';
import '../styles/testimonial.css';
import { useLocation } from "react-router-dom";
import { LiaIndustrySolid } from "react-icons/lia";
import { GrMapLocation } from "react-icons/gr";
import { TbTruckDelivery } from "react-icons/tb";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const Testimonial = () => {

  const { pathname } = useLocation();

  const tbannerRef = useRef(null);
  const tbimgRef = useRef(null);
  const tbtitleRef = useRef(null);
  const moreref = useRef(null);
  const moretextref = useRef(null);
  const tlastref = useRef(null);
  const tlasttextref = useRef(null);

  const companyRef = useRef([]);
  companyRef.current = [];

  const dataRef = useRef([]);
  dataRef.current = [];

  // banner data animation
  useEffect(() => {
    gsap.fromTo(
      tbtitleRef.current, { y: 80, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1.5,
        ease: "power3.out",
        scrollTrigger: {
          trigger: tbannerRef.current,
          start: "top 80%",
        },
      }
    );
  });

  // banner img animation
  useEffect(() => {
    if (!tbimgRef.current) return;

    gsap.registerPlugin(ScrollTrigger);

    const animation = gsap.fromTo(
      tbimgRef.current,
      { scale: 0.65 },
      {
        scale: 1.25,
        scrollTrigger: {
          trigger: tbannerRef.current,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
        },
      }
    );

    return () => {
      animation.scrollTrigger?.kill();
      animation.kill();
    };
  }, []);

  // all imgs and texts animation
  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    companyRef.current.forEach((img, i) => {
      gsap.fromTo(
        img,
        { opacity: 0, scale: 0.9, x: i % 2 === 0 ? -80 : 80 },
        {
          opacity: 1,
          scale: 1,
          x: 0,
          duration: 1.4,
          ease: "power3.out",
          scrollTrigger: {
            trigger: img,
            start: "top 80%",
            end: "top 40%",
            scrub: 1.2,
          },
        }
      );
    });

    dataRef.current.forEach((text, i) => {
      gsap.fromTo(
        text,
        { opacity: 0, y: 40, x: i % 2 === 0 ? 40 : -40 },
        {
          opacity: 1,
          y: 0,
          x: 0,
          duration: 1.4,
          ease: "power3.out",
          scrollTrigger: {
            trigger: text,
            start: "top 85%",
            end: "top 50%",
            scrub: 1.1,
          },
        }
      );
    });
  }, []);

  // last text animation
  useEffect(() => {
    gsap.fromTo(
      tlasttextref.current, { y: 80, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1.5,
        ease: "power3.out",
        scrollTrigger: {
          trigger: tlastref.current,
          start: "top 80%",
        },
      }
    );
  });

  // more company animation
  useEffect(() => {
    gsap.fromTo(
      moretextref.current, { y: 80, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1.5,
        ease: "power3.out",
        scrollTrigger: {
          trigger: moreref.current,
          start: "top 80%",
        },
      }
    );
  });

  useEffect(() => {
    requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    });
  }, [pathname]);

  const images = {
    testimonial: require('../image/testi.png'),
    bs: require('../image/bluestar.jpg')
  };

  const clients = [
    {
      id: 1,
      name: "Blue star",
      img: images.bs,
      since: "2019",
      industry: "Jewellery + Diamond",
      location: "Surat",
      delivered: "480+",
    },
    {
      id: 2,
      name: "K Girdharlal",
      img: "https://images.jdmagicbox.com/v2/comp/surat/s2/0261px261.x261.240912071239.q7s2/catalogue/k-girdharlal-international-pvt-ltd-ghb-surat-diamond-merchants-jozkpmczpw.jpg",
      since: "2021",
      industry: "Diamond",
      location: "Surat",
      delivered: "720+",
    },
    {
      id: 3,
      name: "KP Sanghvi",
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQ1kKUL0Ih3ShTAaIPUxkuiCJvZsD6GIDUsuSOxzSZsw&s=10",
      since: "2020",
      industry: "Diamond",
      location: "Surat",
      delivered: "1000+",
    },
    {
      id: 4,
      name: "S Vinodkumar",
      img: "https://svinodkumar.com/wp-content/uploads/2025/07/DSC01537-1.jpg",
      since: "2020",
      industry: "Jewellery + Diamond",
      location: "Surat",
      delivered: "1000+",
    },
    {
      id: 5,
      name: "KGK",
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTMWwdk_wZ1qLdS96z7BESagnBVz-ZcohaL0IlpRoLwwiNYcS1cWg6mPG8&s=10",
      since: "2020",
      industry: "Diamond",
      location: "Surat",
      delivered: "1000+",
    },
    {
      id: 6,
      name: "Sheetal",
      img: "https://www.sheetal.co/Content/Before_Login/images/aboutsheetal-banner.jpg",
      since: "2020",
      industry: "Jewellery",
      location: "Surat",
      delivered: "1000+",
    },
    {
      id: 7,
      name: "Asian star",
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQHRz3EA9HxuVri1nncjau509_QYtyr7Bf3wcVEqgFZVSktuwMWNhjSEYQ&s=10",
      since: "2020",
      industry: "Diamond",
      location: "Surat",
      delivered: "1000+",
    },
    {
      id: 8,
      name: "Mani",
      img: "https://mani.diamonds/Content/WebStoreFrontContent/images/building-image.png",
      since: "2020",
      industry: "Jewellery",
      location: "Surat",
      delivered: "1000+",
    },
    {
      id: 9,
      name: "Green Lab",
      img: "https://greenlab.diamonds/wp-content/uploads/2023/10/New-Project-14.jpg",
      since: "2020",
      industry: "Jewellery + diamond",
      location: "Surat",
      delivered: "1000+",
    },
    {
      id: 10,
      name: "Zest Co.",
      img: "https://lh3.googleusercontent.com/p/AF1QipOtTbShH12F_RBIdC0BF1m-HYLcBw4puiOEYzVp=s1400-w720-h1400-rw",
      since: "2020",
      industry: "Jewellery",
      location: "Surat",
      delivered: "1000+",
    },
    {
      id: 11,
      name: "Anjali",
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQCmzRjMVUvRviupcWCB6vFm0vjl3XtDk0vzYk7MWj6mQ&s=10",
      since: "2020",
      industry: "Jewellery + diamond",
      location: "Surat",
      delivered: "1000+",
    },
    {
      id: 12,
      name: "Venus",
      img: "https://www.venusjewel.com/images/contact-form-bg-2.jpg",
      since: "2020",
      industry: "Diamond",
      location: "Surat",
      delivered: "1000+",
    },
  ];

  const companies = {
    agiri: require('../company/agiri.webp'),
    davariya: require('../company/davariya.png'),
    dharma: require('../company/dharma.png'),
    dm: require('../company/dm.avif'),
    greenlab: require('../company/greenlab.webp'),
    bluestone: require('../company/bluestone.webp'),
    gurukrupa: require('../company/gurukrupa.webp'),
    anjali: require('../company/anjali.png'),
    kgk: require('../company/kgk.png'),
    mani: require('../company/mani.png'),
    neon: require('../company/neon.webp'),
    kg: require('../company/kg.png'),
    bluestar: require('../company/bluestar.png'),
    sheetal: require('../company/sheetal.png'),
    sparkle: require('../company/sparkleimpex.png'),
    svgroup: require('../company/svgroup.png'),
    venus: require('../company/venus.png'),
    zest: require('../company/zest.png'),

    dome: require('../company/dome.png'),
    multi: require('../company/multiseed.png'),
    om: require('../company/om.png'),
    samarth: require('../company/samarth.png'),
    bookend: require('../company/bookend.png'),
    offside: require('../company/offside.png'),
    doulat: require('../company/doulat.png'),
    kpsanghavi: require('../company/kpsanghavi.png'),
    param: require('../company/param.avif'),
    sukani: require('../company/sukani.png'),
    sitilink: require('../company/sitilink.png'),
    dbe: require('../company/dbe.webp'),
    wonder: require('../company/wonder.png'),
  };


  return (
    <>
      <section className="Testimonial hero_slider" ref={tbannerRef}>
        <img
          ref={tbimgRef}
          src={images.testimonial}
          className="d-block hero_slider_img"
          alt="img-1"
          style={{
            objectFit: 'cover',
            boxShadow: 'rgba(0, 0, 0, 7) 0px -50px 36px -28px inset',
            maskImage:
              "linear-gradient(to bottom, transparent 0%, rgba(0,0,0,1) 10%, rgba(0,0,0,1) 85%, transparent 100%)",
            WebkitMaskImage:
              "linear-gradient(to bottom, transparent 0%, rgba(0,0,0,1) 10%, rgba(0,0,0,1) 85%, transparent 100%)",
          }}
        />
        <Container className="carousel-caption-testimonial col-md-6 col-10 col-offset-md-6">
          <h1 style={{ fontSize: '3.5rem' }} className='banner_text' ref={tbtitleRef}>Every Stitch Tells a Story</h1>
        </Container>
      </section>


      <section className="testimonial-section">
        <h2 className="text-center mb-5">Our Happy Clients</h2>
        <div className={window.innerWidth <= 768 ? "timeline" : "timeline container"}>
          {clients.map((client, index) => (
            <div
              key={client.id}
              ref={(el) => el && (companyRef.current[index] = el)}
              className={`timeline-item ${index % 2 !== 0 ? "reverse" : ""}`}
            >
              <div className="timeline-img">
                <img src={client.img} alt={`Client ${client.id}`} />
              </div>

              <div
                className={`timeline-content ${index % 2 !== 0 ? "text-right" : ""
                  }`}
                ref={(el) => el && (dataRef.current[index] = el)}
              >
                <h1><span className={`${index % 2 !== 0 ? "d-inline" : "d-none"} howbigname`}>{client.name} </span>{client.id}<span className={`${index % 2 !== 0 ? "d-none" : "d-inline"} howbigname`}>{client.name}</span></h1>
                <p className='cont-d-none'>
                  <b>Since :</b> {client.since} &nbsp; | &nbsp;{" "}
                  <b><LiaIndustrySolid /> :</b> {client.industry} Industry
                </p>
                <p className='cont-d-none'>
                  <b><GrMapLocation /> :</b> {client.location} &nbsp; | &nbsp;{" "}
                  <b><TbTruckDelivery /> :</b> {client.delivered} Uniform
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <br /><br /><br />

      <section className="infodata t-center pb-5" ref={moreref}>
        <Container className='middletxt pb-5'>
          <h3 ref={moretextref}>More of Our Valued Clients</h3>
        </Container>
      </section>

      <div className="testiimgcards py-4">
        <Row className="justify-content-center testiimgcards">
          {Object.entries(companies).map(([name, logo], index) => (
            <Col
              key={index}
              xs={6}    // 2 per row on mobile
              sm={4}    // 3 per row on small screens
              md={3}    // 4 per row on medium
              lg={2}    // 6 per row on large screens
              className="d-flex justify-content-center mb-4"
            >
              <div className="company-card">
                <img
                  src={logo}
                  alt={name}
                />
              </div>
            </Col>
          ))}
        </Row>
      </div>

      <br /><br /><br /><br />

      <section className="infodata t-center pb-5" ref={tlastref}>
        <Container className='middletxt pb-5'>
          <h3 ref={tlasttextref}>Looking forward to connecting with more organizations and delivering excellence</h3>
        </Container>
      </section>
    </>
  );
};

export default Testimonial;
